var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.844,
    height: 44.215,
    viewBox: "0 0 42.844 44.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-history",
    "data-name": "Icon awesome-history",
    d: "M43.406,22.628C43.428,34.809,33.8,44.769,22,44.778A20.926,20.926,0,0,1,8.54,39.883a2.184,2.184,0,0,1-.159-3.174l.973-1a2.029,2.029,0,0,1,2.755-.177,15.523,15.523,0,0,0,9.875,3.545,16.145,16.145,0,0,0,15.894-16.4,16.145,16.145,0,0,0-15.894-16.4,15.578,15.578,0,0,0-10.89,4.451l4.384,4.524a1.432,1.432,0,0,1-.977,2.435H1.945A1.4,1.4,0,0,1,.563,16.252V3.293A1.377,1.377,0,0,1,2.922,2.284l4.265,4.4A21,21,0,0,1,21.984.563C33.8.563,43.384,10.438,43.406,22.628ZM27.779,29.652l.848-1.126a2.186,2.186,0,0,0-.364-3L24.748,22.7V13.4a2.107,2.107,0,0,0-2.073-2.139H21.293A2.107,2.107,0,0,0,19.22,13.4V25.492l5.65,4.535a2.03,2.03,0,0,0,2.909-.375Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#367646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.b5140fefe16c2da20f1282def9cedf34.svg";
export { ForwardRef as ReactComponent };